import apiClient from './client';
export const auditApi = {
    async getLogs(filters = {}) {
        const params = new URLSearchParams();
        if (filters.userId)
            params.append('userId', filters.userId);
        if (filters.adminId)
            params.append('adminId', filters.adminId);
        if (filters.action)
            params.append('action', filters.action);
        if (filters.startDate)
            params.append('startDate', filters.startDate);
        if (filters.endDate)
            params.append('endDate', filters.endDate);
        if (filters.page)
            params.append('page', filters.page.toString());
        if (filters.perPage)
            params.append('perPage', filters.perPage.toString());
        const response = await apiClient.get(`/v1/admin/audit-log?${params.toString()}`);
        return response.data;
    },
    async exportToCSV(filters = {}) {
        const params = new URLSearchParams();
        if (filters.userId)
            params.append('userId', filters.userId);
        if (filters.adminId)
            params.append('adminId', filters.adminId);
        if (filters.action)
            params.append('action', filters.action);
        if (filters.startDate)
            params.append('startDate', filters.startDate);
        if (filters.endDate)
            params.append('endDate', filters.endDate);
        const response = await apiClient.get(`/v1/admin/audit-log/export?${params.toString()}`, { responseType: 'blob' });
        return response.data;
    },
};
